import styled from 'styled-components'
import { backgroundOrange, black, white, border1 } from '@/theme/colors'
import { media } from '@/theme/tokens'
import { text } from '@/theme/typography'

export const PageContainer = styled.div`
	background-color: ${backgroundOrange};
	height: 100%;
	display: flex;
	flex-direction: column;
	overflow: hidden;
`

export const ContentRow = styled.div`
	display: flex;
	flex: 1;
	min-height: 0;
	overflow: hidden;

	${media.tablet} {
		flex-direction: column;
	}
`

export const SidePanel = styled.aside`
	width: 380px;
	flex-shrink: 0;
	display: flex;
	flex-direction: column;
	background: ${white};
	border-right: 1px solid ${border1};
	overflow: hidden;

	${media.tablet} {
		width: 100%;
		height: 45%;
		border-right: none;
		border-top: 1px solid ${border1};
		order: 2;
	}
`

export const MapWrapper = styled.div`
	flex: 1;
	position: relative;
	min-width: 0;

	${media.tablet} {
		order: 1;
		height: 55%;
	}
`

export const PageHeader = styled.div`
	padding: 16px 20px 12px;
	display: flex;
	align-items: center;
	gap: 12px;
	flex-shrink: 0;
	border-bottom: 1px solid ${border1};
`

export const PageTitle = styled.h2`
	${text.title}
	color: ${black};
	margin: 0;
`

export const LoadingContainer = styled.div`
	display: flex;
	flex: 1;
	background-color: ${backgroundOrange};
	height: 100%;
`


